export function getPhoneMaxLength(country: string) {
  switch (country.toLowerCase()) {
    case 'jordan':
      return 10;
    case 'pakistan':
      return 10;
    case 'saudi arabia':
      return 9;
    case 'united arab emirates':
      return 9;
    case 'oman':
        return 8;
    case 'egypt':
      return 10;
    default:
      return 12;
  }
}
